import React, { useEffect, useState, useRef } from 'react';
import '../../css/BdStyles.css';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import Cropper from "react-cropper";
import ImageCrop from "../components/ImageCrop";
import "cropperjs/dist/cropper.css";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TagDetailModal from '../components/TagDetailModal';
import { API_BASE_URL } from '../scripts/control';

const BdMovies = () => {
    const { idMovie } = useParams();
    const navigate = useNavigate();
    const { isLoggedIn, isAdmin, login } = useAdminAuth();
    const [movies, setMovies] = useState([]);
    const [expanded, setExpanded] = useState({});
    const [editingMovie, setEditingMovie] = useState(null);
    const [deletingMovie, setDeletingMovie] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showCropModal, setShowCropModal] = useState(false);
    const [showConfirmCloseModal, setShowConfirmCloseModal] = useState(false);
    const [croppedImage, setCroppedImage] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [favorites, setFavorites] = useState({});
    const moviesPerPage = 5;
    const [tags, setTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [showTagsModal, setShowTagsModal] = useState(false);
    const [availableTags, setAvailableTags] = useState([]);
    const [searchFilters, setSearchFilters] = useState({
    text: '',
    duration: '',
    durationComparator: '>', // Por defecto '>'
    selectedTags: [],
    });
    const [filteredMovies, setFilteredMovies] = useState([]);
    const [showSearchOptions, setShowSearchOptions] = useState(false);
    const [editingTagDetails, setEditingTagDetails] = useState({});
    const [showTagDetailModal, setShowTagDetailModal] = useState(false);
    const [currentTagForDetail, setCurrentTagForDetail] = useState(null);
    const selectedMovie = idMovie
        ? movies.find(movie => movie.idMovie === parseInt(idMovie, 10))
        : null;
    const [mediaType, setMediaType] = useState('image'); // 'image' o 'video'
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [playingMovieId, setPlayingMovieId] = useState(null);
    const videoRef = useRef(null);
    const pauseTimeoutRef = useRef(null);
    const [movieName, setMovieName] = useState('');
    const [movieYear, setMovieYear] = useState('');
    const [movieAge, setMovieAge] = useState('');
    const [movieDuration, setMovieDuration] = useState('');
    const [img_alt, setImgAlt] = useState('');
    const [img_url, setImgUrl] = useState('');
    const [video_url, setVideoUrl] = useState('');


     useEffect(() => {
        const fetchMovies = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php?fetchTags=true`);
                const data = await response.json();
                setMovies(data.movies || []);
            } catch (error) {
                console.error('Error al cargar películas:', error);
            }
        };

        fetchMovies();
    }, []);

    useEffect(() => {
        // Aplica los filtros cada vez que cambian
        const applyFilters = () => {
            let filtered = [...movies];
    
            // Filtrar por texto
            if (searchFilters.text) {
                const lowerText = searchFilters.text.toLowerCase();
                filtered = filtered.filter(movie =>
                    movie.movieName.toLowerCase().includes(lowerText) ||
                    movie.movieAge.toString().includes(lowerText) ||
                    movie.movieYear.toString().includes(lowerText) ||
                    movie.tags.some(tag => tag.toLowerCase().includes(lowerText))
                );
            }
    
            // Filtrar por duración
            if (searchFilters.duration) {
                const durationValue = Number(searchFilters.duration);
                if (!isNaN(durationValue)) {
                    filtered = filtered.filter(movie =>
                        searchFilters.durationComparator === '>'
                            ? Number(movie.movieDuration) > durationValue
                            : Number(movie.movieDuration) < durationValue
                    );
                }
            }
    
            // Filtrar por etiquetas seleccionadas
            if (searchFilters.selectedTags.length > 0) {
                filtered = filtered.filter(movie =>
                    searchFilters.selectedTags.every(tag =>
                        movie.tags.includes(tag)
                    )
                );
            }
    
            setFilteredMovies(filtered);
        };
    
        applyFilters();
    }, [movies, searchFilters]);

    // Manejar cambios en los filtros
    const handleFilterChange = (field, value) => {
        setSearchFilters(prevFilters => ({
            ...prevFilters,
            [field]: value,
        }));
    };

    // 1. Obtener las películas y etiquetas juntas
    useEffect(() => {
        const fetchMoviesAndTags = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php?fetchTags=true`);
                const data = await response.json();
    
                if (data.movies && Array.isArray(data.movies)) {
                    // Convertir tags a array (manejar string, array, o valores inválidos)
                    const moviesWithArrayTags = data.movies.map(movie => ({
                        ...movie,
                        tags: Array.isArray(movie.tags) 
                            ? movie.tags 
                            : (typeof movie.tags === 'string' ? movie.tags.split(', ') : [])
                    }));
                    setMovies(moviesWithArrayTags);
                }
    
                if (data.tags && Array.isArray(data.tags)) {
                    setTags(data.tags); 
                }
            } catch (error) {
                console.error('Error al cargar películas y etiquetas:', error);
            }
        };
    
        fetchMoviesAndTags();
    }, []);


    useEffect(() => {
        if (editingMovie) {
            // Convertir nombres de tags a ids
            const tagIds = editingMovie.tags.map(tagName => {
                const tag = tags.find(t => t.tagName === tagName);
                return tag ? tag.idTag : null;
            }).filter(Boolean);
            setSelectedTags(tagIds);
        }
    }, [editingMovie, tags]);

    const handleCreateNew = () => {
        setShowCreateModal(true);
    };
    const handleConfirmClose = () => {
        setEditingMovie(null);
        setShowConfirmCloseModal(false);
    };

    const handleCancelClose = () => {
        setShowConfirmCloseModal(false);
            };

    const handleSaveNewMovieOrEdit = () => {
      if (editingMovie) {
        handleSave();  // Función de edición
      } else {
        handleSaveNewMovie();  // Función de creación
      }
    };
        
    const handleSaveNewMovie = async () => {
      const formData = new FormData();
      const imgAlt = document.getElementById('img_alt').value;
      const movieName = document.getElementById('newMovieName').value;
      const movieYear = document.getElementById('newMovieYear').value;
      const movieAge = document.getElementById('newMovieAge').value;
      const movieDuration = document.getElementById('newMovieDuration').value;
      const tagDetailsMap = {};
      selectedTags.forEach(tagId => {
        tagDetailsMap[tagId] = editingTagDetails[tagId] || "";
      });
    
      // Validaciones
      if (!movieName || !movieAge) {
        alert("Por favor, completa todos los campos obligatorios (Nombre y Clasificación).");
        return;
      }
      if (!Number.isInteger(Number(movieYear)) ||
          !Number.isInteger(Number(movieAge)) ||
          !Number.isInteger(Number(movieDuration))) {
        alert("Los siguientes parámetros deben ser numéricos (Año, clasificación y duración).");
        return;
      }
    
      formData.append('tags', JSON.stringify(selectedTags));
      formData.append('tagDetails', JSON.stringify(tagDetailsMap));
      formData.append('movieName', movieName);
      formData.append('movieYear', movieYear);
      formData.append('movieAge', movieAge);
      formData.append('movieDuration', movieDuration);
      formData.append('img_alt', imgAlt);
      if (mediaType === 'image') {
        if (croppedImage) {
          formData.append('img_url', croppedImage);
        }
      } else if (mediaType === 'video') {
        if (selectedVideo) {
          formData.append('video_url', selectedVideo);
        }
      }
    
      try {
        if (isAdmin) {
          // Admin: guardado directo
          formData.append('action', 'create');
          const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            const newMovie = await response.json();
            // Actualiza el estado local, etc.
            alert("Película guardada correctamente.");
          } else {
            alert("Error al guardar la película.");
          }
        } else {
          // Usuario tipo "user": enviar solicitud para revisión
          formData.append('action', 'submit_create');
          const response = await fetch(`${API_BASE_URL}/api/send_mail_simple.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            alert("Tu solicitud ha sido enviada para revisión.");
          } else {
            alert("Error al enviar la solicitud.");
          }
        }
      } catch (error) {
        console.error('Error en la solicitud:', error);
        alert("Ocurrió un error. Por favor, inténtalo nuevamente.");
      }
      window.location.reload();
    };

    
        const toggleFavorite = (id) => {
            setFavorites((prevFavorites) => ({
                ...prevFavorites,
                [id]: !prevFavorites[id],
            }));
        };
    
        const handleEdit = (movie) => {
          setEditingMovie(movie);
          setEditingTagDetails({ ...movie.tagsDetails });
          setShowModal(true);
          if (movie.video_url) {
            setMediaType('video');
          } else {
            setMediaType('image');
          }
        };
    
        const handleDelete = (movie) => {
            setDeletingMovie(movie);
        };
    
        const confirmDelete = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: deletingMovie.idMovie }),
            });
    
            if (response.ok) {
                setMovies(movies.filter((movie) => movie.idMovie !== deletingMovie.idMovie));
                setDeletingMovie(null);
            } else {
                console.error('Error al borrar la película');
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
        }
    };

    const cancelDelete = () => {
        setDeletingMovie(null);
    };

    const handleSave = async () => {
      const formData = new FormData();
      const movieName = document.getElementById('movieName').value;
      const movieYear = document.getElementById('movieYear').value;
      const movieAge = document.getElementById('movieAge').value;
      const movieDuration = document.getElementById('movieDuration').value;
      
      // Mapear detalles de etiquetas
      const tagDetailsMap = {};
      selectedTags.forEach(tagId => {
        tagDetailsMap[tagId] = editingTagDetails[tagId] || "";
      });
      
      formData.append('tags', JSON.stringify(selectedTags));
      formData.append('tagDetails', JSON.stringify(tagDetailsMap));
      // Si se está editando, incluimos el id de la película
      formData.append('idMovie', editingMovie.idMovie);
      formData.append('movieName', movieName);
      formData.append('movieYear', movieYear);
      formData.append('movieAge', movieAge);
      formData.append('movieDuration', movieDuration);
      if (mediaType === 'image') {
        if (croppedImage) {
          formData.append('img_url', croppedImage);
        }
      } else if (mediaType === 'video') {
        if (selectedVideo) {
          formData.append('video_url', selectedVideo);
        }
      }
      
      try {
        if (isAdmin) {
          // Admin guarda directamente en la base de datos
          formData.append('action', 'update');
          const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            const updatedMovie = await response.json();
            setMovies(prevMovies =>
              prevMovies.map(movie =>
                movie.idMovie === editingMovie.idMovie
                  ? {
                      ...updatedMovie,
                      tags: selectedTags.map(tagId =>
                        tags.find(t => t.idTag === tagId)?.tagName || ""
                      ),
                      tagsDetails: tagDetailsMap
                    }
                  : movie
              )
            );
            setEditingMovie(null);
          } else {
            console.error('Error al actualizar');
          }
        } else {
          // Usuario tipo "user": Enviar solicitud para revisión
          formData.append('action', 'submit_update');
          const response = await fetch(`${API_BASE_URL}/api/send_mail_simple.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            alert("Tu solicitud ha sido enviada para revisión.");
          } else {
            alert("Error al enviar la solicitud.");
          }
        }
      } catch (error) {
        console.error('Error:', error);
        alert("Ocurrió un error. Por favor, inténtalo nuevamente.");
      }
      window.location.reload();
    };


    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setSelectedImage(reader.result);
                setShowCropModal(true);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleCloseModal = () => {
        setShowConfirmCloseModal(true);
    };

    const handleCropSave = (cropped) => {
        setCroppedImage(cropped);
        setShowCropModal(false);
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const indexOfLastMovie = currentPage * moviesPerPage;
    const indexOfFirstMovie = indexOfLastMovie - moviesPerPage;
    const currentMovies = Array.isArray(movies)
    ? movies.slice(indexOfFirstMovie, indexOfLastMovie)
    : [];

    const totalPages = Math.ceil(movies.length / moviesPerPage);
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleTagChange = (tagId) => {
      if (selectedTags.includes(tagId)) {
        setSelectedTags(selectedTags.filter(id => id !== tagId));
      } else {
        setSelectedTags([...selectedTags, tagId]);
      }
    };

    const handleOpenTagDetail = (tagId) => {
      const tag = tags.find(t => t.idTag === tagId);
      if (tag) {
        setCurrentTagForDetail(tag);
        setShowTagDetailModal(true);
      }
    };

    // Para guardar detalles de las etiquetas
    const handleSaveTagDetail = async (detail) => {
      
      setEditingTagDetails(prev => ({ ...prev, [currentTagForDetail.idTag]: detail }));
    
      // Si se está editando una película (existe editingMovie), se realiza la petición al backend
      if (editingMovie) { 
        const formData = new FormData();
        formData.append('action', 'update_tag_details');
        formData.append('idMovie', editingMovie.idMovie);
        formData.append('idTag', currentTagForDetail.idTag);
        formData.append('details', detail);
    
        try {
          const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php`, {
            method: 'POST',
            body: formData,
          });
          if (!response.ok) {
            console.error('Error al guardar el detalle en la base de datos');
          }
        } catch (error) {
          console.error('Error en la petición:', error);
        }
      }
    };


    const clearFilters = () => {
        setSearchFilters({
            text: '',
            duration: '',
            durationComparator: '>',
            selectedTags: [],
        });
    };


    const handleMediaUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        if (mediaType === 'image') {
          // Procesar imagen (usando FileReader y crop)
          const reader = new FileReader();
          reader.onload = () => {
            setSelectedImage(reader.result); // Usado para previsualización y crop
            setShowCropModal(true);
          };
          reader.readAsDataURL(file);
        } else if (mediaType === 'video') {
          // Procesar video: no se realiza crop
          const reader = new FileReader();
          reader.onload = () => {
            setSelectedVideo(reader.result); // Data URL del video para previsualización
          };
          reader.readAsDataURL(file);
          // Opcional: puedes ocultar el crop modal si estuviera abierto
          setShowCropModal(false);
          // Limpia la imagen seleccionada (en caso de haberla)
          setSelectedImage(null);
        }
      }
    };

    const handleVideoPlay = () => {
      if (pauseTimeoutRef.current) {
        clearTimeout(pauseTimeoutRef.current);
        pauseTimeoutRef.current = null;
      }
    };

    const handleVideoPause = () => {
      pauseTimeoutRef.current = setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }
        setPlayingMovieId(null);
      }, 5000);
    };

    const handleVideoEnded = () => {
      setPlayingMovieId(null);
    };

    const handleSaveOrSubmit = async () => {
      const formData = new FormData();
      
      formData.append('movieName', movieName);
      formData.append('movieYear', movieYear);
      formData.append('movieAge', movieAge);
      formData.append('movieDuration', movieDuration);
      formData.append('img_alt', img_alt);
      
      if (mediaType === 'image' && croppedImage) {
        formData.append('img_url', croppedImage);
      } else if (mediaType === 'video' && selectedVideo) {
        formData.append('video_url', selectedVideo);
      }
      
      const tagDetailsMap = {};
      selectedTags.forEach(tagId => {
        tagDetailsMap[tagId] = editingTagDetails[tagId] || "";
      });
      formData.append('tags', JSON.stringify(selectedTags));
      formData.append('tagDetails', JSON.stringify(tagDetailsMap));
      
      if (editingMovie) {
        formData.append('idMovie', editingMovie.idMovie);
      }
      
      try {
        if (isAdmin) {
          // Admin: guardar directamente
          formData.append('action', editingMovie ? 'update' : 'create');
          const response = await fetch(`${API_BASE_URL}/api/bd_movies_func.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            const result = await response.json();
            alert("Película guardada correctamente.");
          } else {
            alert("Error al guardar la película.");
          }
        } else {
          // Usuario: enviar solicitud para revisión (correo)
          formData.append('action', editingMovie ? 'submit_update' : 'submit_create');
          const response = await fetch(`${API_BASE_URL}/api/bd_submit_movie.php`, {
            method: 'POST',
            body: formData,
          });
          if (response.ok) {
            alert("Tu solicitud ha sido enviada para revisión.");
          } else {
            alert("Error al enviar la solicitud.");
          }
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        alert("Ocurrió un error. Por favor, inténtalo nuevamente.");
      }
      
      window.location.reload();
    };

    return (
    <div className="container">
        <h2 className="title">Películas</h2>
        <hr className="small-hr" />
        <br />
        <div className="search-container">

                <button
                    className="btn btn-outline-primary mb-3"
                    onClick={() => setShowSearchOptions(!showSearchOptions)}
                >Buscar
                    <i className="bi bi-search ms-1"></i>
                </button>

                {showSearchOptions && (
                    <div className="search-options p-3 border rounded bg-white">
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Buscar por texto..."
                            value={searchFilters.text}
                            onChange={(e) => handleFilterChange('text', e.target.value)}
                        />

                        <select
                            className="form-select mb-2"
                            value={searchFilters.durationComparator}
                            onChange={(e) => handleFilterChange('durationComparator', e.target.value)}
                        >
                            <option value=">">Mayor que</option>
                            <option value="<">Menor que</option>
                        </select>

                        <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="Duración (minutos)"
                            value={searchFilters.duration}
                            onChange={(e) => handleFilterChange('duration', e.target.value)}
                        />

                        <div className="tags-filter">
                            <p>Filtrar por etiquetas:</p>
                            {tags.map(tag => (
                            <div key={tag.idTag}>
                                <input
                                    type="checkbox"
                                    id={`filter-tag-${tag.idTag}`}
                                    checked={searchFilters.selectedTags.includes(tag.idTag)}
                                    onChange={(e) => {
                                        const updatedTags = e.target.checked
                                            ? [...searchFilters.selectedTags, tag.idTag]
                                            : searchFilters.selectedTags.filter(id => id !== tag.idTag);
                                        handleFilterChange('selectedTags', updatedTags);
                                    }}
                                />
                                <label htmlFor={`filter-tag-${tag.idTag}`}>{tag.tagName}</label>
                            </div>
                        ))}
                        </div>

                        <button
                            className="btn btn-primary mt-3 w-100"
                            onClick={() => setShowSearchOptions(false)}
                        >
                            Aplicar filtros
                        </button>
                        <button
                            className="btn btn-secondary mt-2 w-100"
                            onClick={clearFilters}
                        >
                            Limpiar filtros
                        </button>
                    </div>
                )}
            </div>

        {isLoggedIn && (
            <button
                onClick={handleCreateNew}
                style={{
                    marginBottom: '20px',
                    marginLeft: '25%',
                    padding: '10px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                }}
            >
                Crear nueva película
            </button>
        )}

        <div className="row">
            {filteredMovies.map((movie, index) => (
            <div key={movie.idMovie || index} className="col-md-4 mb-4">
              <div className={`card ${expanded[movie.idMovie] ? 'expanded' : ''}`}>
                <div className="media-container">
                  {/* Imagen siempre renderizada */}
                  {movie.img_url && (
                  <img
                    src={`${API_BASE_URL}/public/uploads/images/${movie.img_url}`}
                    alt={movie.movieName}
                    className={`media-element ${playingMovieId === movie.idMovie ? 'image-hidden' : 'image-visible'}`}
                  />
                )}
                {/* Video solo se activa si es el video activo */}
                 {movie.video_url && (
            <video
              ref={videoRef}
              controls
              autoPlay={playingMovieId === movie.idMovie}
              preload={playingMovieId === movie.idMovie ? 'auto' : 'none'}
              onPlay={handleVideoPlay}
              onPause={handleVideoPause}
              onEnded={handleVideoEnded}
              className={`media-element ${
                playingMovieId === movie.idMovie ? 'video-visible' : 'video-hidden'
              }`}
            >
              <source
                src={`${API_BASE_URL}/public/uploads/videos/${movie.video_url}`}
                type="video/mp4"
              />
              Tu navegador no soporta el elemento de video.
            </video>
          )}
          {/* Botón de play: se muestra solo si hay imagen y video y todavía no se está reproduciendo */}
          {movie.video_url && movie.img_url && playingMovieId !== movie.idMovie && (
            <button className="play-button" onClick={() => setPlayingMovieId(movie.idMovie)}>
              &#9658;
            </button>
          )}
        </div>
        <div className="card-body">
          <h5 className="card-title">{movie.movieName}</h5>
          <p className="card-text">
            <strong>Año:</strong> {movie.movieYear}
          </p>
          <p className="card-text">
            <strong>Clasificación:</strong> {movie.movieAge}
          </p>
          <p className="card-text">
            <strong>Duración:</strong> {movie.movieDuration}
          </p>
          <p className="card-text">
            <strong>Etiquetas:</strong>{' '}
            {Array.isArray(movie.tags)
              ? movie.tags.join(', ')
              : typeof movie.tags === 'string'
              ? movie.tags.split(', ').join(', ')
              : 'Sin etiquetas'}
          </p>
          <Link to={`/ligaincom/bd/detalles/pelicula/${movie.idMovie}`} className="btn btn-primary">
            Ver Detalle
          </Link>

          {/* Contenedor para los botones de edición/borrado */}
          <div style={{ marginTop: '10px' }}>
            {isLoggedIn && (
              <button
                onClick={() => handleEdit(movie)}
                style={{
                  marginRight: '10px',
                  padding: '5px 10px',
                  backgroundColor: '#ffc107',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                }}
              >
                Editar
              </button>
            )}
            {isAdmin && (
              <button
                onClick={() => handleDelete(movie)}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#dc3545',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  color: 'white',
                }}
              >
                Borrar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

        <div className="pagination">
            {pageNumbers.map((number) => (
                <button
                    key={number}
                    onClick={() => paginate(number)}
                    className={`pagination-button ${currentPage === number ? 'active' : ''}`}
                >
                    {number}
                </button>
            ))}
        </div>



{/* Modal de creación de película */}
{showCreateModal && (
  <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Crear Nueva Película</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowCreateModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          {/* Formulario principal */}
          <form>
            <label htmlFor="newMovieName">Nombre:</label>
            <input type="text" id="newMovieName" />

            <label htmlFor="newMovieYear">Año:</label>
            <input type="text" id="newMovieYear" />

            <label htmlFor="newMovieAge">Clasificación:</label>
            <input type="text" id="newMovieAge" />

            <label htmlFor="newMovieDuration">Duración:</label>
            <input type="text" id="newMovieDuration" />

            <label htmlFor="img_alt">Texto alternativo:</label>
            <input type="text" id="img_alt" /><br /><br />

            <div className="media-type-selector">
              <label>
                <input 
                  type="radio" 
                  value="image" 
                  checked={mediaType === 'image'} 
                  onChange={() => setMediaType('image')}
                />
                Imagen
              </label>
              <label>
                <input 
                  type="radio" 
                  value="video" 
                  checked={mediaType === 'video'} 
                  onChange={() => setMediaType('video')}
                />
                Video
              </label>
            </div>
            <input 
              type="file" 
              accept={mediaType === 'image' ? "image/*" : "video/*"} 
              onChange={handleMediaUpload} 
            /><br></br> <br></br>
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={() => setShowTagsModal(true)}
            >
              Seleccionar etiquetas
            </button>
          </form>

          {/* Modal de selección de etiquetas, fuera del form */}
          {showTagsModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Seleccionar etiquetas</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowTagsModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {tags.map(tag => (
                      <div key={tag.idTag} className="d-flex align-items-center mb-2">
                        <input
                          type="checkbox"
                          id={`tag-${tag.idTag}`}
                          checked={selectedTags.includes(tag.idTag)}
                          onChange={() => handleTagChange(tag.idTag)}
                          className="me-2"
                        />
                        <label htmlFor={`tag-${tag.idTag}`} className="me-2">
                          {tag.tagName}
                        </label>
                        {selectedTags.includes(tag.idTag) && (
                          <button 
                            className="btn btn-link p-0" 
                            onClick={(e) => {
                              e.preventDefault();
                              handleOpenTagDetail(tag.idTag);
                            }}
                          >
                            <i className="bi bi-gear-fill text-secondary"></i>
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowTagsModal(false)}
                    >
                      Guardar selección
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer">
        {isAdmin && (
          <button type="button" className="btn btn-primary" onClick={handleSaveNewMovieOrEdit}>
            Guardar película
          </button>
        )}
        {(!isAdmin && isLoggedIn) && (
          <button type="button" className="btn btn-primary" onClick={handleSaveNewMovieOrEdit}>
            Enviar película
          </button>
        )}
        </div>
      </div>
    </div>
  </div>
)}


        {/* Modal de edición */}
        {editingMovie && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Editar Película</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleCloseModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <label htmlFor="movieName">Nombre:</label>
                                <input type="text" id="movieName" defaultValue={editingMovie.movieName} />
                                <label htmlFor="movieYear">Año:</label>
                                <input type="text" id="movieYear" defaultValue={editingMovie.movieYear} />
                                <label htmlFor="movieAge">Clasificación:</label>
                                <input type="text" id="movieAge" defaultValue={editingMovie.movieAge} />
                                <label htmlFor="movieDuration">Duración:</label>
                                <input type="text" id="movieDuration" defaultValue={editingMovie.movieDuration} />
                                <label htmlFor="img_alt">Texto alternativo:</label>
                                <input type="text" id="img_alt" /><br /><br />
                    
                                <div className="media-type-selector">
                                  <label>
                                    <input 
                                      type="radio" 
                                      value="image" 
                                      checked={mediaType === 'image'} 
                                      onChange={() => setMediaType('image')}
                                    />
                                    Imagen
                                  </label>
                                  <label>
                                    <input 
                                      type="radio" 
                                      value="video" 
                                      checked={mediaType === 'video'} 
                                      onChange={() => setMediaType('video')}
                                    />
                                    Video
                                  </label>
                                </div>
                                <input 
                                  type="file" 
                                  accept={mediaType === 'image' ? "image/*" : "video/*"} 
                                  onChange={handleMediaUpload} 
                                /><br></br> <br></br>
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar etiquetas</h5>
                                </div>
                                <div className="modal-body">
                                    {tags.map(tag => (
                                        <div key={tag.idTag} className="d-flex align-items-center mb-2">
                                            <input
                                                type="checkbox"
                                                id={`tag-${tag.idTag}`}
                                                checked={selectedTags.includes(tag.idTag)}
                                                onChange={() => handleTagChange(tag.idTag)}
                                                className="me-2"
                                            />
                                            <label htmlFor={`tag-${tag.idTag}`} className="me-2">
                                                {tag.tagName}
                                            </label>
                                            
                                            {/* Ícono para detalles (solo si el tag está seleccionado) */}
                                            {selectedTags.includes(tag.idTag) && (
                                                <button 
                                                    className="btn btn-link p-0" 
                                                    onClick={(e) => {
                                                        e.preventDefault(); 
                                                        handleOpenTagDetail(tag.idTag)
                                                    }}
                                                >
                                                    <i className="bi bi-gear-fill text-secondary"></i>
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleCloseModal}
                                    >
                                        Cancelar
                                    </button>
                                    {isAdmin && (

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSave}
                                    >
                                        Guardar
                                    </button>
                                    )}
                                    {(!isAdmin && isLoggedIn) && (

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSave}
                                    >
                                        Enviar
                                    </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        {/* Modal de confirmación de cierre */}
        {showConfirmCloseModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmar cierre</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={handleCancelClose}></button>
                        </div>
                        <div className="modal-body">
                            <p>¿Quieres abandonar la edición? Se perderán los cambios no guardados.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleCancelClose}>Volver</button>
                            <button type="button" className="btn btn-primary" onClick={handleConfirmClose}>Salir</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        {/* Modal de confirmación de borrado */}
        {deletingMovie && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmar borrado</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={cancelDelete}></button>
                        </div>
                        <div className="modal-body">
                            <p>¿Estás seguro de que deseas borrar el artículo {deletingMovie.title}?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={cancelDelete}>Cancelar</button>
                            <button type="button" className="btn btn-danger" onClick={confirmDelete}>Borrar</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        {/* Modal de recorte */}
        {showCropModal && (
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Recortar Imagen</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowCropModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <ImageCrop image={selectedImage} onImageSave={handleCropSave} />
                        </div>
                    </div>
                </div>
            </div>
        )}
        {showTagDetailModal && currentTagForDetail && (
          <TagDetailModal
            tag={currentTagForDetail}
            initialDetail={editingTagDetails[currentTagForDetail.idTag] || ''}
            onSave={handleSaveTagDetail}
            onClose={() => setShowTagDetailModal(false)}
          />
        )}
        </div>
    );
};
export default BdMovies;
